import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CustomValidators } from 'ng2-validation';
import { Subscription } from 'rxjs/Subscription';
import { UrlConfig } from 'config/urlConfig';
import { NetworkService } from 'services/network.service';
import { EmailService } from 'services/email.service';
import { SalesForceService } from 'services/salesforce.service';
import { FooterNavbarService } from 'services/connectors/footer-navbar.service';
import { Constants } from 'config/constants';
import { SpinnerService } from 'services/spinner.service';

@Component({
    selector: 'tpc-events-gate',
    templateUrl: './events-gate.component.html',
    styleUrls: ['./events-gate.component.css']
})
export class EventsGateComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    private isFormSubmitted = false;
    public countryList = [];
    public gateForm: FormGroup;

    constructor(private emailService: EmailService,
                private footerService: FooterNavbarService,
                private router: Router,
                private fb: FormBuilder,
                private salesForceService: SalesForceService,
                private networkService: NetworkService,
                private spinner: SpinnerService) {
        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmitted = true;
            if (this.gateForm.status === 'VALID') {
                this.next();
            }
        });
        this.createForm();
    }

    ngOnInit() {
        this.getCountryList();
    }

    private createForm() {
        this.gateForm = this.fb.group({
            name: ['', [
                Validators.required,
                Validators.minLength(2),
                Validators.maxLength(50),
                Validators.pattern(/^[A-Za-z0-9\-\s]+$/i)]],
            event: ['', [
                Validators.required,
                Validators.minLength(2),
                Validators.maxLength(50),
                Validators.pattern(/^[A-Za-z0-9,.\-\s]+$/i)]],
            company: ['', [
                Validators.required,
                Validators.minLength(2),
                Validators.maxLength(50),
                Validators.pattern(/^[A-Za-z0-9,.\-\s]+$/i)]],
            industry: ['', [Validators.required]],
            email: ['', [
                Validators.required,
                Validators.minLength(5),
                Validators.maxLength(50),
                CustomValidators.email]],
            phone: ['', [
                Validators.required,
                Validators.minLength(7),
                Validators.maxLength(20),
                Validators.pattern(/^[0-9+\-]+$/i)]],
            country: ['',  [
                Validators.required,
                Validators.minLength(1),
                Validators.maxLength(50),
                Validators.pattern(/^[A-Za-z0-9,.\-\s]+$/i)]],
        });
    }

    private getCountryList(): void {
        this.spinner.show();
        this.networkService.post(UrlConfig.getUrl('getStateAndCountry'), { }).subscribe(
        country => {
                this.countryList = country;
                this.spinner.hide();
            }
        );
    }

    private next() {
        let calculatorName = Constants.calculators.events;
        let params = {
            name: this.getFV('name'),
            event: this.getFV('event'),
            company: this.getFV('company'),
            industry: this.getFV('industry'),
            email: this.getFV('email'),
            phone: this.getFV('phone'),
            country:  this.getFV('country')
        };

        this.spinner.show();
        // check count of emails from this user
        this.networkService.post(UrlConfig.getUrl('checkEmail'), {email: params.email}).subscribe(
            response => {
                let numberOfAttempts = response[0].Attempts;

                if (numberOfAttempts > Constants.limitPerOneEmailPerDay) {
                    this.router.navigate(['/limit']);
                    this.spinner.hide();
                    return;
                }

                this.emailService.sendEventsGateEmail(params, data => {
                });

                this.salesForceService.send(params, calculatorName).subscribe(
                    () => {
                        this.spinner.hide();
                        this.router.navigate(['/events/travel/default']);
                    }
                );
            }
        );
    }

    checkError(param) {
        return this.gateForm.get(param).status === 'INVALID' && (this.isFormSubmitted || this.gateForm.get(param).touched);
    }

    getFV(param) {
        return this.gateForm.get(param).value;
    }

    ngOnDestroy() {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/events-calculator/events-gate/events-gate.component.ts